@if (showEnableFeature) {
  <div class="row button-container">
    <div class="col-2 custom-button">
      <div class="rSet enable-alo-label">
        <label aria-hidden="true">
          Enable feature
          <input type="checkbox" class="primary-checkbox" name="enableFeature"
            [(ngModel)]="isEnableFeature" (change)="enableFeatureChanged($event.target.checked)" />
          <span class="extra-border-enablefeat" id="LowMainsLock-enable-feature"></span>
        </label>
      </div>
    </div>
    <div class="col-8"></div>
    <div class="col-1"></div>
  </div>
}

<div class="row slider-container activedim-margin" [ngClass]="{'isResetDisabled': lowmainslockDisabled && showEnableFeature}">
  <div class="col-1 label signifyBookmd dim-margin zero-margin-top" id="LowMainsLock-duration-label">Low mains duration</div>
  @if (quickConfigvalue) {
    <div class="col-2">
      <div class="row">
        <div class="col-4"></div>
        <div class="col-2 minValMargin">
          <span id="LowMainsLock-duration-STDmin" class="signifyBookmd minValue"> min {{lowMainsDurationMin}}</span>
        </div>
        <div class="col-3">
          <span id="LowMainsLock-duration-STDmax" class="signifyBookmd maxValue"> max {{lowMainsDurationMax}}</span>
        </div>
      </div>
    </div>
  }
  @if (!quickConfigvalue) {
    <span class="signifyBookmd text-mindim sliderMinValue col-1" id="LowMainsLock-duration-min">{{lowMainsDurationMin}}</span>
  }
  @if (!quickConfigvalue) {
    <div class="col-6 curvePadding sliderCss" id="LowMainsLock-duration-slider" [ngClass]="{'isSliderClick': lowmainslockDisabled && showEnableFeature}">
      <ngx-slider type="normalType" id="LowMainsLock-duration-range" ngDefaultControl
        [value]="getSliderSafeValue(lowMainsDuration, lowMainsDurationMin, lowMainsDurationMax)" [options]="lowMainsDurationOptions"
        (userChangeEnd)="lowMainsDurationChange($event.value)">
      </ngx-slider>
    </div>
  }
  @if (!quickConfigvalue) {
    <span class="signifyBookmd text-mindim col-1 startUpMargin" id="LowMainsLock-duration-max">{{lowMainsDurationMax}}</span>
  }
  <div class="row form-group col-3">
    <input type="number" [value]="lowMainsDurationDisplayValue" step="1" aria-label="Low mains duration"
      class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" id="LowMainsLock-duration-input"
      (input)="onFieldInput($event.target, 'lowMainsDuration')" (blur)="onFieldBlur($event.target, 'lowMainsDuration')"
      [disabled]="lowmainslockDisabled && showEnableFeature" (keypress)="numberOnly($event)"
      [ngClass]="{'myStyle': inputError['lowMainsDuration']===true, 'isResetDisabled custom-inputbox-disabled': lowmainslockDisabled && showEnableFeature, 'inputCssStandard': quickConfigvalue===true}" />
    <p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">s</p>
  </div>
</div>

